<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'SliderComponent.vue'
}
</script>

<style scoped></style>
